/**
 * 基于 Element UI 表单验证封装的工具类。验证器必须返回一个方法，异常情况需要抛出一个异常
 */
export default class Validator {
  constructor(rule, value, cb) {
    this.rule = rule;
    this.value = value;
    this.cb = cb;
    this.rules = [];
  }

  static _isNumber(value) {
    return /^[0-9]*$/.test(value);
  }

  /**
   * 添加一个内部验证器
   * @param rule
   * @returns {Validator}
   */
  register(rule) {
    this.rules.push(rule);
    return this;
  }

  /**
   * 添加一个自定义验证器，要求返回一个方法
   * @param fn
   * @returns {Validator}
   */
  define(fn) {
    this.rules.push(fn(this.rule, this.value, this.cb));
    return this;
  }

  /**
   * 进行验证
   * @param done 如果该值为 truly，则在验证通过后直接执行 cb 回调
   */
  validate(done = true) {
    const result = this.rules.every(item => {
      try {
        item();
        return true;
      } catch (e) {
        this.cb(e);
        return false;
      }
    });

    if (result && done) this.cb();
  }

  /**
   * 要求必填
   */
  required(message = `该字段不能为空`) {
    return () => {
      if (!this.value.trim()) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求是数字
   */
  isNumber(message = `该值必须是数值型`) {
    return () => {
      if (!Validator._isNumber(this.value)) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求值相等
   */
  isEqual(val, message = `两个值不相等`) {
    return () => {
      if (this.value !== val) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求值不相等
   */
  isNotEqual(val, message = `两个值相等`) {
    return () => {
      if (this.value === val) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求是大写字母、小写字母、数字或下划线组成的标准字符串
   */
  isStandardStr(message = `请输入大写字母、小写字母、数字或下划线`) {
    return () => {
      if ((this.value.match(/[^a-zA-Z0-9_]/g))) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求字段值必须在范围内。参数是左开右闭区间
   */
  range(min, max, message = `该字段的值必须大于等于 ${min} 且小于 ${max}`) {
    return () => {
      if (!Validator._isNumber(this.value)) {
        throw new Error(`该值必须是数值型`);
      }

      if (!(this.value >= min && this.value < max)) {
        throw new Error(message);
      }
    };
  }

  /**
   * 要求字段长度
   */
  lenRange(min, max, message = `该字段的长度必须大于等于 ${min} 且小于 ${max}`) {
    return () => {
      if (!(this.value.length >= min && this.value.length < max)) {
        throw new Error(message);
      }
    };
  }
}
